import {
  UPDATE_TABLE,
  RESET_TABLE,
  LOAD_MODEL,
  RESIZE_TABLE,
  COLAPSE_DASH,
  GET_COLLECTION_TABLE,
  CLOSE_TAB,
  SET_ACTIVE_TAB,
  UNASSIGN_FROM_COLLECTIONS,
  ADD_TO_NEW_COLLECTION,
  COPY_TO_COLLECTION, COPY_TO_COLLECTION_UNSAVED,
  ASSIGN_TO_COLLECTION, REPLACE_TAB, ADD_SELECT_ITEMS
} from "../constans";
import {tabType} from "../../utils/data";

const initState = {
  tabs: [],
  offSetSize: 250,
  colapsedDash: "opened",
};
const tableReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case UPDATE_TABLE:

      const inactiveTabs = state.tabs.filter((tab) => tab.type !== tabType.report).map((tab) => { return {...tab, active: false} });

      return {
        ...state,
        tabs: [{...payload, id: 1, type: tabType.report, name: "Report", active: true, collection: {groupBy: payload.groups, properties: payload.properties} }, ...inactiveTabs],
      };
    case RESET_TABLE:

      return {
        ...initState,
        offSetSize: state.offSetSize,
        colapsedDash: state.colapsedDash,
      };
    case RESIZE_TABLE:

      return {
        ...state,
        offSetSize: payload,
      };
    case COLAPSE_DASH:
      return {
        ...state,
        colapsedDash: payload,
      };
    case LOAD_MODEL:

      return {
        ...initState,
        offSetSize: state.offSetSize,
        colapsedDash: state.colapsedDash,
      };
    case GET_COLLECTION_TABLE:

      const duplicateTab = state.tabs.filter((tab) => tab.id === payload.collection.creationTime);

      const tabsWithoutActive = state.tabs.map((tab) => {
        if(tab.id !== payload.collection.creationTime) {
          return {...tab, active: false};
        } else {
          return {...tab, active: true};
        }
      });

      return {
        ...initState,
        tabs: duplicateTab.length ? tabsWithoutActive : [...tabsWithoutActive, {id: payload.collection.creationTime, type: tabType.saved, active: true, name: payload.collection.title, color: payload.collection.color, collection: payload.collection, folder: payload.folder, ...payload.tableCollection}],
        offSetSize: state.offSetSize,
        colapsedDash: state.colapsedDash,
      };

    case CLOSE_TAB:

      const openTabs = state.tabs.filter((tab) => payload.id !== tab.id);

      if(payload.active && openTabs.length) {
        const lastTab = openTabs.pop();
        openTabs.push({...lastTab, active: true});
      }

      return {
        ...initState,
        tabs: [...openTabs],
      };
    case SET_ACTIVE_TAB:

      const newActiveTabs = state.tabs.map((tab) => {

        tab.selectItems = null;

        if(payload.id === tab.id) {
          return {...tab, active: true};
        } else {
          return {...tab, active: false};
        }
      });

      return {
        ...initState,
        tabs: newActiveTabs,
      };
    case UNASSIGN_FROM_COLLECTIONS:

      const newUnassignArray = state.tabs.map((tab) => {
        if(payload.id === tab.id) {
          return {...tab, ...payload};
        } else {
          return tab;
        }
      });

      return {
        ...initState,
        tabs: newUnassignArray,
      };
    case ADD_TO_NEW_COLLECTION:

      let amountUnsavedTabs = 1;

      state.tabs.forEach((tab) => {
        if(tab.type === tabType.unsaved) {
          amountUnsavedTabs +=1;
        }
      })

      const newName = "New selection set " + amountUnsavedTabs;

      return {
        ...initState,
        tabs: [...state.tabs, {id: Date.now(), type: tabType.unsaved, active: false, name: newName, collection: payload.collection, ...payload.tableCollection}]
      };
    case COPY_TO_COLLECTION:

      const newCopyToArray = state.tabs.map((tab) => {
        if(tab.id === payload.id) {
          return {...tab, ...payload.tableCollection};
        } else {
          return tab;
        }
      });

      return {
        ...initState,
        tabs: newCopyToArray,
      };
    case ASSIGN_TO_COLLECTION:

      const newAssignToArray = state.tabs.map((tab) => {
        if(tab.id === payload.id) {
          return {...tab, ...payload.tableCollection};
        } else {
          return tab;
        }
      });

      return {
        ...initState,
        tabs: newAssignToArray,
      };
    case COPY_TO_COLLECTION_UNSAVED:

      const newCopyToArrayUnsaved = state.tabs.map((tab) => {
        if(tab.id === payload.id) {
          return {...tab, ...payload.tableCollection};
        } else {
          return tab;
        }
      });

      return {
        ...initState,
        tabs: newCopyToArrayUnsaved,
      };
    case REPLACE_TAB:

      const replaceTabArray = state.tabs.map((tab) => {
        if(tab.id === payload.id) {
          return {...tab, ...payload, name: payload.collectionName, color: payload.color, type: "saved", id: payload.collection.creationTime};
        } else {
          return tab;
        }
      });

      return {
        ...initState,
        tabs: replaceTabArray,
      };
    case ADD_SELECT_ITEMS:

      const addSelectItems = state.tabs.map((tab) => {
        if(tab.id === payload.id) {
          return {...tab, selectItems: payload.selectItems};
        } else {
          return tab;
        }
      });

      return {
        ...initState,
        tabs: addSelectItems,
      };
    default:
      return state;
  }
};
export default tableReducer;
